import { AWARD_TYPE } from '@/constants/awards'

/**
 * This returns the award context for goal, kr, initiative
 *
 * @param entity - object for goal, kr, initiative
 * @param entityType - goal | kr | initiative
 * @returns {}
 */
export default (entity, entityType) => {
  const context = {
    recipientIds: [entity.ownerId, ...entity.coOwnerIds],
    orgId: entity.organizationId,
    contextTitle: entity.title,
    contextId: entity.id
  }
  if (entityType === 'kr') {
    context.contextType = AWARD_TYPE.KEY_RESULT
    context.type = AWARD_TYPE.KEY_RESULT
  } else if (entityType === 'goal') {
    context.contextType = AWARD_TYPE.GOAL
    context.type = AWARD_TYPE.GOAL
  } else if (entityType === 'initiative') {
    context.contextType = AWARD_TYPE.INITIATIVE
    context.type = AWARD_TYPE.INITIATIVE
  }
  return context
}
